import { useEffect } from 'react';
import { useSeoMeta } from '@unhead/react';

import { siteConfig } from '@/config/site';
import { SiteHeader } from '@/components/SiteHeader';
import { HeroSection } from '@/components/HeroSection';
import { AboutSection } from '@/components/AboutSection';
import { ProjectsSection } from '@/components/ProjectsSection';
import { NotesFeed } from '@/components/NotesFeed';
import { SiteFooter } from '@/components/SiteFooter';

const Index = () => {
  useSeoMeta({
    title: `${siteConfig.name} — Open-Source Bitcoin & Nostr Developer`,
    description: siteConfig.tagline,
  });

  // Support cross-page anchor links like "/#notes" after a full navigation.
  useEffect(() => {
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      el?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <main>
        <HeroSection />
        <AboutSection />
        <ProjectsSection />
        <NotesFeed />
      </main>
      <SiteFooter />
    </div>
  );
};

export default Index;
